import { prefix } from '@goldwasserexchange/react-topmodel';
export var aPrefixer = prefix('A');
